import React, { useState } from "react";
import "./Get_Free_Cruise.css";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Common_Btn_Yellow from "../../common_component/common_btn_yellow/Common_Btn_Yellow";

import Success_Modal from "../../contact-us/success_modal/Success_Modal";
import { postData } from "../../../utils/api";

function GetFreeCruise() {
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const country_code = [{ value: "91", label: "+91" }];

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    const payload = {
      departure: data.departure,
      sail_month: data.sail_month,
      duration: data.duration,
      full_name: data.full_name,
      email: data.email,
      phone: data.phone,
    };

    try {
      const response = await postData(
        "/master/cruise-package-inquiry/",
        payload,
      );

      if (response?.success) {
        setShowSuccessModal(true);

        setTimeout(() => {
          setShowSuccessModal(false);
        }, 3000);

        reset();
      } else {
        alert(response?.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);
      alert("Server error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="cruise-section">
      <div className="cruise-banner">
        <div className="img_wrapper">
          <img
            src="/assets/images/cruise/cruise-banner.png"
            alt="Cruise Banner"
          />
        </div>
      </div>

      <div className="cruise-form-card container">
        <h3 className="form-title">Get Free Cruise Quote</h3>

        <Form className="inquiry-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <Form.Group className="input_group">
                <Form.Label>Departure City</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter departure city"
                  {...register("departure", { required: true })}
                />
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-6">
              <Form.Group className="input_group">
                <Form.Label>Sail Month</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter sail month"
                  {...register("sail_month", { required: true })}
                />
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-6">
              <Form.Group className="input_group">
                <Form.Label>Duration (ex. 7D & 8N)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter duration"
                  {...register("duration", { required: true })}
                />
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-6">
              <Form.Group className="input_group">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your full name"
                  {...register("full_name", { required: true })}
                />
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-12">
              <Form.Group className="input_group">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email address"
                  {...register("email", { required: true })}
                />
              </Form.Group>
            </div>

            <div className="col-lg-4 col-sm-12">
              <Form.Group className="input_group">
                <Form.Label>Phone Number</Form.Label>

                <div className="row">
                  <div className="col-sm-4 col-4">
                    <Controller
                      name="country_code"
                      control={control}
                      defaultValue={country_code[0]}
                      render={({ field }) => (
                        <Select {...field} options={country_code} />
                      )}
                    />
                  </div>

                  <div className="col-8">
                    <Form.Control
                      type="text"
                      placeholder="Enter your phone number"
                      {...register("phone", { required: true })}
                    />
                  </div>
                </div>
              </Form.Group>
            </div>
          </div>

          <div className="inquiry_wrapper">
            <Common_Btn_Yellow
              type="submit"
              text={isSubmitting ? "Sending..." : "Send Inquiry"}
              disabled={isSubmitting}
            />
          </div>
        </Form>
      </div>

      <Success_Modal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
      />
    </section>
  );
}

export default GetFreeCruise;
